export default "__VITE_ASSET__kMeyGStr__"